export const bileteral = `
<svg width="30" height="30" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<path
    d="M46.5244 38.4401L50 50L37.0307 46.9022L24.0622 43.8048L30.5602 38.0126L25.1582 33.1976L31.1496 27.857L36.5516 32.6721L43.0499 26.8801L46.5244 38.4401ZM36.5516 17.3279L43.0499 23.1201L46.5248 11.5602L50 0L37.0312 3.09788L24.0622 6.19515L30.5602 11.9874L0 39.2277L5.99151 44.5682L21.953 30.3406L25.1202 27.5176L36.5516 17.3279ZM18.7476 16.8023L5.9914 5.43202L0.000113259 10.7725L12.7562 22.1428L18.7476 16.8023Z"
    fill="white" />
</svg>
`